module.exports = {
          srcSet: __webpack_public_path__ + "public/d91d5b3c3893269e1ea5efc99026ce6d-40.png"+" 40w",
          images:[ {path: __webpack_public_path__ + "public/d91d5b3c3893269e1ea5efc99026ce6d-40.png",width: 40,height: 40}],
          src: __webpack_public_path__ + "public/d91d5b3c3893269e1ea5efc99026ce6d-40.png",
          toString:function(){return __webpack_public_path__ + "public/d91d5b3c3893269e1ea5efc99026ce6d-40.png"},
          
          width: 40,
          height: 40
        }